import {LOADING, LOADED} from './actionTypes';

export const loading = () => ({
  type: LOADING,
});

export const loaded = () => ({
  type: LOADED,
});
